import config from "../../config/config";
import { writeContractAndWait } from "../viem";

const unwrapAbi = [
  {
    type: "function",
    name: "unwrap",
    stateMutability: "nonpayable",
    inputs: [{ name: "itemIds", type: "uint256[]" }],
    outputs: [],
  },
] as const;

export const unwrapFounderTableShareItems = async (
  account: string,
  itemIds: number[]
) =>
  writeContractAndWait({
    address: config.ftsAddress,
    abi: unwrapAbi,
    functionName: "unwrap",
    args: [itemIds],
    account,
  });
